// extracted by mini-css-extract-plugin
export default {"statsTop":"cMAje","grid":"lURQ7","statsBottom":"URv7U","projectTop":"PJgkl","loaderWrapper":"ynoaw","loader":"oYFpI"};